import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs/index';
import { Notification, NotificationType } from '../models/notification';

@Injectable()
export class NotificationsService {
  public subject = new Subject<Notification>();
  private keepAfterRouteChange = false;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterRouteChange) {
          this.keepAfterRouteChange = false;
        } else {
          this.clear();
        }
      }
    });
  }

  public getNotification(): Observable<Notification> {
    return this.subject.asObservable();
  }

  /**
   * Success Notification message
   * @param message string
   * @param time number, if 0 - without progress and auto close
   * @param keepAfterRouteChange boolean
   */
  public success(message: string, time: number = 10, keepAfterRouteChange: boolean = false) {
    this.notification(NotificationType.Success, message, time, keepAfterRouteChange);

    // public success(message: string, keepAfterRouteChange = false) {
    //   this.notification(NotificationType.Success, message, keepAfterRouteChange);

  }

  /**
   * Error Notification message
   * @param message string
   * @param time number, if 0 - without progress and auto close
   * @param keepAfterRouteChange boolean
   */
  public error(message: string, time: number = 10, keepAfterRouteChange: boolean = false) {
    this.notification(NotificationType.Error, message, time, keepAfterRouteChange);
  }

  /**
   * Info Notification message
   * @param message string
   * @param time number, if 0 - without progress and auto close
   * @param keepAfterRouteChange boolean
   */
  public info(message: string, time: number = 10, keepAfterRouteChange: boolean = false) {
    this.notification(NotificationType.Info, message, time, keepAfterRouteChange);
  }

  /**
   * Warning Notification message
   * @param message string
   * @param time number, if 0 - without progress and auto close
   * @param keepAfterRouteChange boolean
   */
  public warn(message: string, time: number = 10, keepAfterRouteChange: boolean = false) {
    this.notification(NotificationType.Warning, message, time, keepAfterRouteChange);
  }

  private notification(type: NotificationType, message: string, time?: number, keepAfterRouteChange: boolean = false) {
    this.keepAfterRouteChange = keepAfterRouteChange;
    const notification = new Notification(type, message, time);
    this.subject.next(notification);
  }

  public clear() {
    this.subject.next();
  }
}
